module.exports = __webpack_public_path__ + "static/media/remove.602cf7f9.svg";